export const DOC_CATALOG = [
    { id: "certificazioni", label: "Certificazioni", items: [
        { id: "ape", label: "APE (Attestato Prestazione Energetica)" },
        { id: "ace", label: "ACE" },
        { id: "cert_elettrico", label: "Certificazione Impianto Elettrico" },
        { id: "cert_gas", label: "Certificazione Impianto Gas" },
        { id: "cert_idrico", label: "Certificazione Impianto Idrico" },
        { id: "conformita", label: "Certificato di Conformità" },
        { id: "agibilita", label: "Certificato di Agibilità / Abitabilità" },
    ] },
    { id: "catastale", label: "Documentazione Catastale", items: [
        { id: "visura", label: "Visura Catastale" },
        { id: "scheda_catastale", label: "Scheda Catastale" },
        { id: "planimetria", label: "Planimetria Catastale" },
        { id: "planimetria_arredata", label: "Planimetria Arredata" },
        { id: "planimetria_quotata", label: "Planimetria Quotata" },
        { id: "mappa", label: "Estratto di Mappa" },
        { id: "elaborato", label: "Elaborato Planimetrico" },
    ] },
    { id: "urbanistica", label: "Documentazione Urbanistica", items: [
        { id: "cila", label: "CILA" },
        { id: "cila_sanatoria", label: "CILA in Sanatoria" },
        { id: "scia", label: "SCIA" },
        { id: "dia", label: "DIA" },
        { id: "permesso_costruire", label: "Permesso di Costruire" },
        { id: "concessione", label: "Concessione Edilizia" },
        { id: "condono", label: "Condono Edilizio" },
        { id: "cdu", label: "Certificato di Destinazione Urbanistica" },
    ] },
    { id: "proprieta", label: "Documentazione Proprietà", items: [
        { id: "atto_provenienza", label: "Atto di Provenienza" },
        { id: "atto_successione", label: "Atto di Successione" },
        { id: "atto_donazione", label: "Atto di Donazione" },
        { id: "scritture_private", label: "Scritture Private" },
    ] },
    { id: "tecnica", label: "Documentazione Tecnica", items: [
        { id: "perizia", label: "Perizia Tecnica" },
        { id: "relazione", label: "Relazione Tecnica" },
        { id: "regolamento_cond", label: "Regolamento Condominiale" },
        { id: "verbali_cond", label: "Verbali Assemblea Condominiale" },
        { id: "spese_cond", label: "Spese Condominiali" },
        { id: "ordinanze", label: "Ordinanze" },
    ] },
    { id: "contratti", label: "Contratti", items: [
        { id: "contratto_locazione", label: "Contratto di Locazione" },
        { id: "contratto_leasing", label: "Contratto Leasing" },
        { id: "convenzioni", label: "Convenzioni" },
    ] },
    { id: "identificativi", label: "Documenti Identificativi", items: [
        { id: "carta_identita", label: "Carta d'Identità Proprietario" },
        { id: "codice_fiscale", label: "Codice Fiscale Proprietario" },
    ] },
];

export const DOC_TYPE_LABELS = Object.fromEntries(
    DOC_CATALOG.flatMap((c) => c.items.map((i) => [i.id, i.label])).concat([["altro", "Altro documento"]])
);

export const docStatus = (doc) => {
    if (!doc) return "mancante";
    try {
        const days = (Date.now() - new Date(doc.uploaded_at).getTime()) / 86400000;
        if (days > 365) return "da_aggiornare";
    } catch { /* noop */ }
    return "caricato";
};

export const STATUS_META = {
    caricato: { label: "Caricato", dot: "bg-green-400", text: "text-green-300" },
    da_aggiornare: { label: "Da aggiornare", dot: "bg-amber-400", text: "text-amber-300" },
    mancante: { label: "Mancante", dot: "bg-red-400", text: "text-red-400/70" },
};
